import React from 'react';
import { Hero } from './Hero';
import { ProblemSection } from './ProblemSection';
import { SolutionSection } from './SolutionSection';
import { HowItWorks } from './HowItWorks';
import { Pricing } from './Pricing';
import { FAQ } from './FAQ';
import { CTASection } from './CTASection';
import { usePageTracking } from '@/shared/components/usePageTracking';

export function LandingPage() {
  // Track landing page view
  usePageTracking('/');

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <ProblemSection />
      <SolutionSection />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <CTASection />
    </div>
  );
}